<template>
  <div v-if="isLoading" id="wrapper">
    <section class="assessmentHeader">
      <LazyLearningLevelAssessmentHeaderTop
          :track-title="assessmentStore.trackInfo.title"
      />
      <LazyLearningLevelAssessmentHeaderBottom
          :level-assessment="levelAssessment"
      />
    </section>
    <LazyLearningLevelAssessmentStart
        :track-title="assessmentStore.trackInfo.title"
        :level-assessment="levelAssessment"
        :level-assessment-info="levelAssessmentInfo"
        @on-click-button="methods.onClickButtonOf"
    />
    <LazyLearningLevelAssessmentFooter />
  </div>
</template>

<script setup lang="ts">
import {
  LazyLearningLevelAssessmentFooter,
  LazyLearningLevelAssessmentHeaderBottom,
  LazyLearningLevelAssessmentHeaderTop,
  LazyLearningLevelAssessmentStart
} from "#components";
import {computed, onMounted, ref, useI18n, useRoute, useRouter} from "#imports";
import {useUserStore} from "~/store/user/userStore";
import {useLearningStore} from "~/store/learning/learningStore";
import {useLearningAssessmentStore} from "~/store/learning/assessment/learningAssessmentStore";
import {useLevelAssessmentService} from "~/composables/service/useLevelAssessmentService";
import {LevelAssessmentModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentModel";
import {LevelAssessmentButtonStatus} from "~~/package/mapper/levelAssessment/model/LevelAssessmentButtonStatus";
import type LevelAssessmentIdListResponse from "~~/package/apis/levelAssessment/response/LevelAssessmentIdListResponse";
import {useGenericDialog} from "~/composables/useGenericDialog";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const learningStore = useLearningStore();
    const assessmentStore = useLearningAssessmentStore();
const { openWrongApproachAlert } = useGenericDialog();

const isLoading = ref(false);
const trackId = parseInt(route.params.trackId as string);
const levelId = parseInt(route.params.levelId as string);
const levelAssessmentInfo = ref(new LevelAssessmentModel());

const levelAssessment = computed(() =>
  `${assessmentStore.trackInfo.trackLevelTitle} ${t('skillCertify-assessment', 1)}`
);

onMounted(() => {
  if (!userStore.isLogin()) methods.goToHomePage();
  else methods.getLevelAssessmentInfo();
});

const methods = {
  getLevelAssessmentInfo() {
    useLevelAssessmentService().getLevelAssessmentInfo(levelId)
        .then(levelAssessment => {
          levelAssessmentInfo.value = levelAssessment;
          learningStore.updateTrackLevelInfo(levelAssessment, levelId)
          isLoading.value = true;
        }).catch(() => { methods.openFailPopup() });
  },
  openFailPopup() {
    openWrongApproachAlert();
  },
  goToHomePage() {
    router.replace({path: "/"});
  },
  onClickButtonOf(btnStatus: LevelAssessmentButtonStatus) {
    if (!btnStatus) {
      router.push({
        path: `/learning/levelAssessment/result/${trackId}/${levelId}`
      });
    } else {
      useLevelAssessmentService().getLevelAssessmentIdList(levelId, btnStatus)
          .then((data: LevelAssessmentIdListResponse) => {
            assessmentStore.levelAssessmentIdList = data.questionIdList;
            assessmentStore.solvedQuestion = data.solvedQuestion;
            router.push({
              path: `/learning/levelAssessment/${trackId}/${levelId}/${assessmentStore.levelAssessmentIdList[0]}`
            });
          })
          .catch(() => { methods.openFailPopup() });
    }
  }
}
</script>
